
{
  "familyId": "GET-GROOT-SCHATTEN",
  "questions": [
    {
      "id": "GET-GROOT-SCHATTEN-001",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "fill_in",
      "question": "Een school heeft 387 leerlingen. Rond dit af op honderdtallen. 387 ≈ ___",
      "options": [],
      "correctAnswer": "400",
      "stimulusAids": [],
      "supportAids": [
        {"type": "numberline", "showWhen": "wrong", "data": {"start": 300, "end": 500, "marked": [387], "step": 100, "label": "387 op de getallenlijn tussen 300 en 500"}},
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten = afronden op een handig getal", "content": "387 ligt tussen 300 en 400. Kijk naar het tientallencijfer: 8 ≥ 5, dus rond je omhoog af naar 400.", "icon": "lightbulb"}}
      ],
      "pedagogy": {"dok": 1},
      "conceptId": "schatten_honderdtallen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "387 ligt tussen 300 en 400. Het tientallencijfer is 8 (≥ 5), dus je rondt omhoog af: 387 ≈ 400.",
        "solutionSteps": ["387 ligt tussen 300 en 400", "Tientallencijfer = 8", "8 ≥ 5 → rond omhoog af", "387 ≈ 400"]
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-002",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Je wilt 48 × 21 schatten. Welke schatting is het handigst?",
      "options": ["50 × 20 = 1.000", "48 × 20 = 960", "40 × 20 = 800", "50 × 25 = 1.250"],
      "correctAnswer": 0,
      "misconceptionTags": ["rounds_only_one_factor", "rounds_too_far_down", "rounds_to_wrong_multiple"],
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten bij vermenigvuldigen", "content": "Rond beide getallen af naar 'makkelijke' getallen. 48 ≈ 50 en 21 ≈ 20. Dan: 50 × 20 = 1.000.", "icon": "lightbulb"}}],
      "pedagogy": {"dok": 2},
      "conceptId": "schatten_vermenigvuldiging",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond beide getallen af naar 'makkelijke' getallen: 48 ≈ 50 en 21 ≈ 20. Dan: 50 × 20 = 1.000. Het echte antwoord is 1.008, dus de schatting is heel nauwkeurig!",
        "solutionSteps": ["Rond af: 48 ≈ 50 (dichtbij, makkelijk getal)", "Rond af: 21 ≈ 20 (dichtbij, makkelijk getal)", "Schat: 50 × 20 = 1.000", "Check: exact is 48 × 21 = 1.008 ✓"],
        "distractorExplanations": {
          "0": "Goed! 50 × 20 = 1.000 is de handigste schatting.",
          "1": "Je rondt maar één getal af. 48 × 20 = 960 is nauwkeurig, maar niet de handigste schatting. Onthoud: bij schatten rond je beide getallen af.",
          "2": "48 is dichter bij 50 dan bij 40. Door te ver af te ronden wordt je schatting minder nauwkeurig: 800 in plaats van 1.008.",
          "3": "21 is dichter bij 20 dan bij 25. 50 × 25 = 1.250 is te hoog. Rond af naar het dichtstbijzijnde tiental."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-003",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "fill_in",
      "question": "In een stadion zitten 23.456 mensen. Rond dit af op duizendtallen. 23.456 ≈ ___",
      "options": [],
      "correctAnswer": "23000",
      "stimulusAids": [],
      "supportAids": [
        {"type": "numberline", "showWhen": "wrong", "data": {"start": 23000, "end": 24000, "marked": [23456], "step": 500, "label": "23.456 op de getallenlijn tussen 23.000 en 24.000"}},
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Afronden op duizendtallen", "content": "Kijk naar het honderdtallencijfer. In 23.456 is dat de 4. 4 < 5 → rond naar beneden af: 23.000.", "icon": "lightbulb"}}
      ],
      "pedagogy": {"dok": 1},
      "conceptId": "schatten_duizendtallen",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Kijk naar het honderdtallencijfer in 23.456: dat is de 4. 4 < 5 → rond naar beneden af. 23.456 ≈ 23.000.",
        "solutionSteps": ["Afronden op duizendtallen → kijk naar de honderdtallen", "Het honderdtallencijfer is 4", "4 < 5 → rond naar beneden af", "23.456 ≈ 23.000"]
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-004",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Je wilt 312 + 489 schatten. Welke schatting past het best?",
      "options": ["300 + 500 = 800", "300 + 400 = 700", "310 + 490 = 800", "350 + 500 = 850"],
      "correctAnswer": 0,
      "misconceptionTags": ["rounds_wrong_direction", "rounds_to_tientallen_not_honderdtallen", "rounds_to_wrong_nearest"],
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten bij optellen", "content": "Rond beide getallen af op honderdtallen. 312 ≈ 300 (1 < 5 → naar beneden). 489 ≈ 500 (8 ≥ 5 → naar boven). Dan: 300 + 500 = 800.", "icon": "lightbulb"}}],
      "pedagogy": {"dok": 2},
      "conceptId": "schatten_optelling",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Rond beide getallen af op honderdtallen: 312 ≈ 300 (tientallencijfer 1 < 5) en 489 ≈ 500 (tientallencijfer 8 ≥ 5). Dan: 300 + 500 = 800. Exact: 801 ✓",
        "solutionSteps": ["Rond af: 312 ≈ 300 (1 < 5 → naar beneden)", "Rond af: 489 ≈ 500 (8 ≥ 5 → naar boven)", "Schat: 300 + 500 = 800", "Check: exact is 312 + 489 = 801 ✓"],
        "distractorExplanations": {
          "0": "Goed! 300 + 500 = 800 is de beste schatting.",
          "1": "Het tientallencijfer van 489 is 8 (≥ 5), dus je rondt omhoog af naar 500, niet naar beneden naar 400.",
          "2": "310 + 490 = 800 geeft hetzelfde antwoord, maar bij schatten kies je de makkelijkste getallen. Rond af op honderdtallen, niet op tientallen.",
          "3": "312 is dichter bij 300 (verschil 12) dan bij 350 (verschil 38). Rond af naar het dichtstbijzijnde honderdtal."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-005",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "fill_in",
      "question": "Een boek heeft 196 pagina's. Je hebt er 52 gelezen. Hoeveel pagina's moet je nog ongeveer lezen? Rond af en reken. Antwoord: ongeveer ___ pagina's",
      "options": [],
      "correctAnswer": "150",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten in context", "content": "Rond af en reken dan. 196 ≈ 200 en 52 ≈ 50. Dan: 200 − 50 = 150.", "icon": "lightbulb"}}],
      "pedagogy": {"dok": 2},
      "conceptId": "schatten_aftrekking_context",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond af: 196 ≈ 200 en 52 ≈ 50. Dan: 200 − 50 = 150. Het exacte antwoord is 144, dus de schatting is goed!",
        "solutionSteps": ["Rond af: 196 ≈ 200", "Rond af: 52 ≈ 50", "Schat: 200 − 50 = 150", "Check: exact is 196 − 52 = 144 ✓"]
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-006",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "true_false_series",
      "question": "Zijn deze schattingen goed of fout?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {"text": "738 ≈ 700 (afgerond op honderdtallen)", "isTrue": true},
          {"text": "4.621 ≈ 5.000 (afgerond op duizendtallen)", "isTrue": true},
          {"text": "253 ≈ 200 (afgerond op honderdtallen)", "isTrue": false},
          {"text": "6.872 ≈ 6.000 (afgerond op duizendtallen)", "isTrue": false}
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Afrondingsregel", "content": "Kijk naar het cijfer rechts van de positie waarop je afrondt. Is het 5 of meer? → Rond omhoog af. Is het minder dan 5? → Rond naar beneden af.", "icon": "lightbulb"}}],
      "pedagogy": {"dok": 2},
      "conceptId": "schatten_beoordelen",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "738: tientallencijfer 3 < 5 → 700 ✓. 4.621: honderdtallencijfer 6 ≥ 5 → 5.000 ✓. 253: tientallencijfer 5 ≥ 5 → moet 300 zijn, niet 200 ✗. 6.872: honderdtallencijfer 8 ≥ 5 → moet 7.000 zijn, niet 6.000 ✗.",
        "solutionSteps": [
          "738 → tientallencijfer 3 < 5 → 700 ✓ Goed",
          "4.621 → honderdtallencijfer 6 ≥ 5 → 5.000 ✓ Goed",
          "253 → tientallencijfer 5 ≥ 5 → moet 300 zijn, niet 200 ✗ Fout",
          "6.872 → honderdtallencijfer 8 ≥ 5 → moet 7.000 zijn, niet 6.000 ✗ Fout"
        ]
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-009",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "estimation_slider",
      "question": "Schat: waar hoort 347 op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 1000,
        "correctValue": 347,
        "tolerancePercent": 10,
        "showNumberLine": true,
        "showValue": false
      },
      "pedagogy": {"dok": 2},
      "conceptId": "schatten_slider_1000",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "347 ligt ongeveer op een derde van de lijn tussen 0 en 1000. Het is iets minder dan de helft (500).",
        "solutionSteps": ["Kijk naar de getallenlijn van 0 tot 1000", "De helft is 500", "347 is minder dan 500, maar meer dan 250 (een kwart)", "Plaats de schuif op ongeveer een derde van de lijn"]
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-010",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "estimation_slider",
      "question": "Schat: waar hoort 4.500 op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 10000,
        "correctValue": 4500,
        "tolerancePercent": 10,
        "showNumberLine": true,
        "showValue": false
      },
      "pedagogy": {"dok": 2},
      "conceptId": "schatten_slider_10000",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "4.500 ligt net iets voor het midden van de lijn tussen 0 en 10.000. Het midden is 5.000.",
        "solutionSteps": [
          "Kijk naar de getallenlijn van 0 tot 10.000",
          "De helft is 5.000",
          "4.500 is iets minder dan 5.000",
          "Plaats de schuif net voor het midden"
        ]
      }
    }
  ]
}
